/**
 * Accordion scripts
 */
import $ from "jquery";

$(document).ready(function() {
    $('.accordion-header').on( 'click', function() {
        var panelId = $(this).attr('aria-controls');
        var panel = $('#' + panelId);
        var isExpanded = $(this).attr('aria-expanded') === 'true';

        $(this).attr('aria-expanded', !isExpanded);
        //panel.css('max-height', !isExpanded ? panel.prop('scrollHeight') + 'px' : 0);
        if (!isExpanded) panel.slideDown(); else panel.slideUp();
    });
});
